import React, { useState, useEffect } from "react";
import {
  TextField,
  ThemeProvider,
  createTheme,
  Autocomplete,
  Button,
} from "@mui/material";
import { Fragment, useMemo, useRef } from "react";
import {
  useAsyncDebounce,
  useBlockLayout,
  useColumnOrder,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import axios from "axios";
// import { common_axios } from "../../..";
// import { common_axios } from "../../../App";
import { common_axios } from "../../../../App";
import { Form, Formik, useFormik, Field, FieldArray } from "formik";
import * as yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import Loader from "../../../../components/Loader";
import Backdrop from "@mui/material/Backdrop";
import DeleteIcon from "@mui/icons-material/Delete";
import ColumnFilter from "../../Reacttable/UserManagement/ReactTableFiles/ColumnFilter";
import { InputAdornment, Tooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { withRouter, useParams } from "react-router-dom";
import RuleIcon from "@mui/icons-material/Rule";
import { Link } from "react-router-dom";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import TextareaAutosize from "@mui/material/TextareaAutosize";
// import ChooseFileExample from "../../secure/Contact/ChooseFileExample";
// import contactfile from "./././../../../../src/file/Contact.xlsx";
import contactfile from "././../../../../file/Contact.xlsx"
import RefreshIcon from "@mui/icons-material/Refresh";
import SettingsBackupRestoreRoundedIcon from "@mui/icons-material/SettingsBackupRestoreRounded";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

const Uploadphonebook = () => {

  const customId1 = "custom-id-yess";

  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: { color: "red" },
        },
      },
    },
  });
  const [downloaddata, setDownloaddata] = useState("");
  const [open, setOpen] = useState();
  const [file, setFile] = useState("");
  const [arrayvalue, setArrayValue] = useState("default");
  //  console.log(arrayvalue, "array222");
  // console.log(ContactArray, "ContactArray77");
  const [hideSkeleton, setHideSkeleton] = useState();
  const [totalPage, setTotalPage] = useState();
  const [totalPageCount, settotalPageCount] = useState();
  const [disabledPrevious, setDisabledPrevious] = useState(true);
  const [disableNext, setDisableNext] = useState(true);
  const [PageSize1, setPageSize1] = useState(10);
  // const[disableTable,setDisableTable] = useState(true);
  // const[FilterButton,setFilterButton] = useState(false);
  const [pageNumber1, setPageNumber1] = useState(0);
  // ----------------------------------------Table-----------------------
  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);
// console.log("data table------", data1);
  const [selectedUserDetail, setSelectedUserDetail] = useState(undefined);
  const [selectedUserDetailApprove, setSelectedUserDetailApprove] = useState(undefined);
  const [Status, setStatus] = useState("allUser");
  const [id, setId] = useState("");
  const defaultColumn = useMemo(() => {
    return {
      Filter: ColumnFilter,
    };
  }, []);
  const modelButtonReject = useRef(null);
  const modelButtonApprove = useRef(null);

  const approveUserModal = async (cell) => {
    // console.log(cell.row.original);
    await setSelectedUserDetailApprove(cell.row.original);
    await modelButtonApprove.current.click();
  };

  const rejectUserModal = async (cell) => {
    // console.log(cell.row.original);
    await setSelectedUserDetail(cell.row.original);
    await modelButtonReject.current.click();
  };
  const approveUser = async (cpId) => {
    const res = await common_axios(`/admin/v1/user/approve/?cpId=${cpId}`);
    await setStatus("approved");

    // console.log(res.data);
  };
  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
      },
      {
        Header: "Filename",
        accessor: "filename",
      },
      {
        Header: "Date",
        accessor: "fileUpload",
      },
      {
        Header: "Total Upload",
        accessor: "totalCount",
      },
      {
        Header: " Total Success",
        accessor: "successCount", // accessor is the "key" in the data
      },
      {
        Header: "Total Failure",
        accessor: "failureCount",
      },
      {
        Header: "Status",
        accessor: "fileStatus",
        Cell: (cell) => (
          <div className="">
            <button
              className="btn color_1  "
              type="button"
              id="dropdownMenuButton1"
              aria-expanded="false"
            >
              {/* {console.log("cell111", cell)} */}
              {cell.row.original.fileStatus == 0 ? (
                <>
                  <span class="badge bg-warning">Pending</span>
                </>
              ) : (
                <>
                  <span class="badge bg-success ">Success</span>
                </>
              )}

              {/* {/ <DeleteIcon /> /} */}
            </button>
          </div>
        ),
      },

      {
        Header: "Download",
        accessor: "downloadUrl",
        Cell: (cell) => (
          <div className="">
            {/* <a  href={cell.row.original.downloadUrl} > */}
            <button
              className="btn color_1 "
              type="button"
              id=""
              data-bs-toggle=""
              aria-expanded="false"
              onClick={() => {
                downloadFile(cell);
              }}
            >
              <FileDownloadIcon />
            </button>
            {/* </a> */}
          </div>
        ),
      },
    ],
    []
  );
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    // footerGroups,
    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      // initialState: { pageIndex: 1 }
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
  );

  const { globalFilter, pageIndex, pageSize } = state;

  const [globalSearchValue, setGlobalSearchValue] = useState(globalFilter);

  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 1000);

  const deletUser = () => {
    // console.log({ selectedFlatRows });
  };

  const changeOrder = () => {
    setColumnOrder(["id", "username", "action", "role", "email"]);
  };

  const uploadreset = () => {
    document.getElementById("fileName").value = "";
  };
  //---------------------------------------------End table------------------------------------//

  function handleChange(event) {
    setFile(event.target.files[0]);
  }

  function handleChange1(event) {
    setArrayValue(event.target.value);
  }

  // .....................................Formik............................................//
  async function ContactGet(values) {
    try {
      // setOpen(true);
      setHideSkeleton(true);

      const res = await common_axios.get(
        `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/phone-books/v2/list`,
      );
      if (res.data.statusdescription.statusCode == 200) {
        // setOpen(false);
        setHideSkeleton(false);
        setData1(res.data.listOfPlaysmsPhonebook);

        // toast.success("Added successfully!!", {
        //   theme: "colored",
        // });
      } else {
        setHideSkeleton(false);

        // setOpen(false);
        toast.error(res.data.statusdescription.statusDescription, {
          toastId: customId1,
        });
      }
    } catch (error) {
      setHideSkeleton(false);

      // setOpen(false);
      toast.error("Please Check Your Network", {
        toastId: customId1,
      });
    }
  }

  async function ChooseFile(event) {
    // console.log("qqq",arrayvalue)
    try {
      setOpen(true);

      if (arrayvalue == "default") {
        const formData = new FormData();
        // event.currentTarget.disabled = true; //to disable upload button after one click......
        formData.append("username", localStorage.getItem("usernamedisplayed"));
        formData.append("phone_book", file);
         formData.append("phoneBookId","0");
        const res = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v1/phone-book/upload`,
          formData
        );
                                                                            
        // console.log("respoformdata--", res);                                 
                                
        if (res.data.statusdescription.statusCode == 200) {
          document.getElementById("fileName").value = "";                                 
          setOpen(false);                   
          BulkTableget();
          // setDownloaddata(res.data.downloadUrl);
          toast.success("File uploaded successfully", {
            theme: "colored",
          });
        } else {
          setOpen(false);
          toast.error(res.data.statusdescription.statusDescription);
        }
      } else {
        const formData = new FormData();
        // event.currentTarget.disabled = true; //to disable upload button after one click......
        formData.append("phone_book", file);
        formData.append("username", localStorage.getItem("usernamedisplayed"));
        formData.append("phoneBookId", arrayvalue);
        const res = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v1/phone-book/upload`,
          formData
        );

        // console.log("respoformdata--", res);

        if (res.data.statusdescription.statusCode == 200) {
          document.getElementById("fileName").value = "";

          // setHide(true);
          setOpen(false);
          BulkTableget();
          setDownloaddata(res.data.downloadUrl);
          toast.success("File uploaded successfully", {
            theme: "colored",
          });
        } else {
          setOpen(false);
          toast.error(res.data.statusdescription.statusDescription);
        }
      }
    } catch (error) {
      setOpen(false);
      // toast.error("Check Your Network");
    }
  }
  const username = localStorage.getItem("usernamedisplayed");
  async function BulkTableget() {
    try {
      const result = await common_axios(

        `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v1/group-upload/fetch-all-data?username=${username}&pageNo=${pageNumber1}&pageSize=${PageSize1}&status=${"Phone-Book"}`,
      );
      if (result.data.statusdescription.statusCode == 200) {
        setData(result.data.fileUploads.content);
        await setTotalPage(result.data.fileUploads.totalPages);
        await settotalPageCount(result.data.fileUploads.pageable.pageNumber);
        setDownloaddata(result.data.downloadUrl);
      } else {
        // setTableLoader(false);
        setOpen(false);
        toast.error(result.data.statusDescription.statusdescription, {
          toastId: customId1,
        });
        // console.log(result.data.statusMessage);
      }
    } catch (error) {
      toast.error("Please check your network", {
        toastId: customId1,
      });
    }
  }
  const downloadFile = (cell) => {
    // console.log("hlooooooo",cell.row.original.downloadUrl);
    // alert("hii");
    window.location.href = cell.row.original.downloadUrl; //to download the file from url in download button
    BulkTableget();
  };
  useEffect(() => {
    BulkTableget();
  }, [pageNumber1, PageSize1]);

  useEffect(() => {
    ContactGet();
  }, []);
  // console.log("aaaa",ContactArray)
  
  const NextPage = () => {
    setPageNumber1(pageNumber1 + 1);
    // setPageNumber(pageNumber1);
    // gotoPage(pageNumber1);
  };

  const PreviousPage = () => {
    setPageNumber1(pageNumber1 - 1);
  };

  useEffect(() => {
    if (totalPageCount > totalPage) {
      settotalPageCount(0);
      setPageNumber1(0);
    }
  }, [totalPageCount]);
  return (
    <>
      <main className="main-content position-relative border-radius-lg ">
        <div>
          <Backdrop
            sx={{
              color: "#fff",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={open}
          >
            <Loader />
          </Backdrop>
        </div>
        <div className="card-body px-0">
          <div className="card shadow-none border bg_blue mt-4">
            <span className="badge rounded-pill bg-primary mt-n3 ms-5">
              Bulk Upload
            </span>
            <div className="card-body text-lg-start text-center">
              <section class="cmp">
                <div class="container-fluid">
                  <div class="row">
                    <section class="col-md-12 right_panel px-0">
                      <div class="tab-content" id="pills-tabContent">
                        <ThemeProvider theme={theme}>
                          <div
                            class="tab-pane fade show active"
                            id="pills-home"
                            role="tabpanel"
                            aria-labelledby="pills-home-tab"
                          >
                            <div className="card-body text-lg-start text-center">
                              <div className="row">
                                <div class="col-md-4">
                                  {hideSkeleton == true ? (
                                    <>
                                      <Box sx={{ width: 150 }}>
                                        <Skeleton />
                                        <Skeleton animation={false} />
                                      </Box>
                                    </>
                                  ) : (
                                    <>
                                      <FormControl
                                        required
                                        fullWidth
                                        size="small"
                                      >
                                        <InputLabel
                                          id="demo-simple-select-autowidth-
                                    label"
                                        >
                                          PhoneBook List
                                        </InputLabel>
                                        <Select
                                          labelId="demo-simple-select-autowidth-label"
                                          id="demo-simple-select-autowidth"
                                          value={arrayvalue}
                                          onChange={handleChange1}
                                          autowidth
                                          label=" PhoneBook List"
                                        >
                                          <MenuItem selected value="default">
                                            default
                                          </MenuItem>
                                          {data1.map((arg) => {
                                            return (
                                              <MenuItem value={arg.id}>
                                                {" "}
                                                {arg.phonebookName}
                                              </MenuItem>
                                            );
                                          })}
                                        </Select>
                                      </FormControl>
                                    </>
                                  )}
                                  {/* 
      <Autocomplete
                                  disablePortal
                                  // disabled={userAccountDisable}
                                  id="combo-box-demo"
                                  options={ContactArray}
                                  getOptionLabel={(option) =>
                                    `${option.groupName}`
                                  }
                                  // value={accountValue}
                                  onChange={(e, index) => {
                                    handleChange1(e, index);
                                  }}
                                  sx={{ width: 300 }}
                                  renderInput={(params) => (
                                    <TextField
                                      // value={accountValue}
                                      // required
                                      {...params}
                                      label="Select Contact List"
                                    />
                                  )}
                                /> */}
                                </div>
                                <div className="col-md-8">
                                  <div class="input-group ">
                                    <Button
                                      variant="contained"
                                      component="label"
                                      style={{
                                        backgroundColor: "white",
                                        boxShadow: "none",
                                        height: "40px",
                                        border: "1px solid #d2d6da",
                                        padding: "0px 0px 0px 0px",
                                        margin: "0px -3px 0px 0px",
                                      }}
                                    >
                                      <input
                                        id="fileName"
                                        type="file"
                                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                        onChange={handleChange}
                                        style={{ color: "#7b809a" }}
                                      />
                                    </Button>
                                    <div className="d-inline-flex mt-2">
                                      <span className="ms-4">
                                        (Reference File)
                                      </span>
                                      <span>
                                        <Link
                                          to={contactfile}
                                          target="_blank"
                                          download="Reference.xlsx"
                                          className="xlsx"
                                        >
                                          xlsx
                                        </Link>
                                      </span>
                                      {/* <Link to={contactfile} target="_blank" download="Reference.xlsx">
                  Download Here
                </Link> */}
                                    </div>

                                    <button
                                      // disabled={hide}
                                      type="button"
                                      className="btn btn_wt_8 bg-gradient-primary m-0 ms-5 radius d-flex align-items-center"
                                      style={{ width: "auto" }}
                                      onClick={ChooseFile}
                                    >
                                      Upload
                                      <FileUploadIcon
                                        style={{ fontSize: "17px" }}
                                      />
                                    </button>
                                    <div>
                                      <button
                                        onClick={uploadreset}
                                        type="button"
                                        className="btn bg-gradient-secondary ms-2 w_btn btn_w8 m-0"
                                        // onClick={Reset}
                                      >
                                        Reset
                                        {/* <i class="material-icons opacity-10 ">
                        settings_backup_restore
                      </i> */}
                                        <SettingsBackupRestoreRoundedIcon
                                          style={{ fontSize: "17px" }}
                                        />
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <p className=" mb-0  text text-center float-en p_51 mt-2">
                                {/* Field(s) marked with{" "} */}
                                Fields required in file Contact name, Mobile
                                Number, Email, Bulklist Name
                                <span className="text-danger fw-bold"></span>
                              </p>
                            </div>
                          </div>
                        </ThemeProvider>
                      </div>
                    </section>
                  </div>
                </div>
              </section>
          
              {/* <section class="modal_1">
         
          <div
            class="modal fade"
            id="exampleModal6"
            tabindex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">
                    Modal title
                  </h5>
                  <button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div class="modal-body">
                  <form class="m-0">
                    <div class="">
                      <div class="row align-items-center">
                        <div class="col-4">
                          <label
                            for="exampleInputEmail1"
                            class="form-label m-0"
                          >
                            number list name:
                          </label>
                        </div>
                        <div class="col-8">
                          <input
                            type="text"
                            class="form-control"
                            id="exampleInputEmail1"
                            aria-describedby="emailHelp"
                          />
                        </div>
                      </div>
                      <div class="row mt-2">
                        <div class="col-4">
                          <label
                            for="exampleInputTextarea"
                            class="form-label m-0"
                          >
                            description:
                          </label>
                        </div>
                        <div class="col-8">
                          <textarea
                            class="form-control"
                            placeholder="Leave a comment here"
                            id="exampleInputTextarea"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                    <div class="bxg_8 mt-3">
                      <div class="flt_start">
                        <div class="float-start d-flex align-items-center flex-wrap">
                          
                          <div class="form-check">
                            <div class="">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="flexRadioDefault"
                                id="flexRadioDefault1"
                                onclick="radio_1()"
                              />
                            </div>
                            <label
                              class="form-check-label"
                              for="flexRadioDefault1"
                            >
                              from file
                            </label>
                          </div>
                          <div class="form-check ms-2">
                            <div class="">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="flexRadioDefault"
                                id="flexRadioDefault2"
                                onclick="radio_2()"
                                checked=""
                              />
                            </div>
                            <label
                              class="form-check-label"
                              for="flexRadioDefault2"
                            >
                              direct input
                            </label>
                          </div>
                        
                        </div>
                      </div>
                      <div class="row align-items-center my-2">
                        <div class="col-4">
                          <label
                            for="exampleInputEmail1"
                            class="form-label m-0"
                          >
                            upload from csv/txt/xls/xlsx
                          </label>
                        </div>
                        <div class="col-8">
                          <input
                            type="text"
                            class="form-control"
                            id="exampleInputEmail1"
                            aria-describedby="emailHelp"
                          />
                        </div>
                      </div>
                      <p>
                        <b class="text-capitalize">note:</b> jdksvc ewbhvber
                        webvweb vfvvwer fvewrre vferwver vfervgrv dfverv vfrev
                        vferver vfrerre vferver vrrervr
                      </p>
                    </div>
                    <button
                      type="button"
                      class="btn btn-primary d-flex align-items-center text-capitalize m-0 ms-auto mt-4"
                    >
                      <i class="fas fa-save d-block"></i>
                      <span class="d-block ms-1">upload & save</span>
                    </button>
                  </form>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                  <button type="button" class="btn btn-primary">
                    Save changes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section> */}
              {/* ---------------------------------Table------------------------------------------ */}

              {/* -------------------------------------End table------------------------------------------- */}
            </div>
          </div>
        </div>

        <div>
          <div className="card shadow-none border bg_blue mt-4">
            <span className="badge rounded-pill bg-primary mt-n3 ms-5">
              Bulk File Upload List{" "}
            </span>
            <div className="card-body text-lg-start text-center">
              {/* ............................Table Code.................. */}
              <div className="d-flex justify-content-between mt-3">
              <select
                            value={pageSize}
                            className="dropdown"
                            onChange={(e) => {
                              setPageSize(Number(e.target.value));
                              setPageSize1(Number(e.target.value));
                            }}
                          >
                            {[10, 25, 50].map((value, i) => {
                              return (
                                <option
                                  className="dropdown-menu"
                                  aria-labelledby="dropdownMenuButton1"
                                  value={value}
                                  key={value}
                                >
                                  {" "}
                                  Show {value}
                                </option>
                              );
                            })}
                          </select> 

                <div className="d-flex align-items-center">
                  {/* <span className="d-block">Search</span> */}
                  <TextField
                    className="ms-4 w-100"
                    style={{
                      borderRadius: "4px",
                    }}
                    type="text"
                    label="Search"
                    name="Search"
                    variant="outlined"
                    // value={number}
                    size="small"
                    value={globalSearchValue || ""}
                    onChange={(e) => {
                      onChange(e.target.value);
                      setGlobalSearchValue(e.target.value);
                    }}
                  />
                </div>
              </div>
              <div>
                {selectedUserDetail != undefined && (                       
                  <div>
                    <button
                      ref={modelButtonReject}
                      type="button"
                      className="btn btn-primary d-none"
                      data-bs-toggle="modal"
                      data-bs-target="#staticBackdrop"
                    >
                      Launch static backdrop modal
                    </button>

                    <div
                      className="modal fade"
                      id="staticBackdrop"
                      data-bs-backdrop="static"
                      data-bs-keyboard="false"
                      tabindex="-1"
                      aria-labelledby="staticBackdropLabel"
                      aria-hidden="true"
                    >
                      <div className="modal-dialog">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5
                              className="modal-title"
                              id="staticBackdropLabel"
                            >
                              Are you sure to delete?
                            </h5>
                            <button
                              type="button"
                              className="btn-close"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                            ></button>
                          </div>

                          {/* <div className="modal-body">
                                    <TextField
                                      disabled
                                      className="ms-4 w-50  "
                                      style={{
                                        borderRadius: "4px",
                                        marginTop: "10px",
                                      }}
                                      type="text"
                                      label="Mobile Number"
                                      name="rules"
                                      variant="outlined"
                                      size="small"
                                      value={selectedUserDetail.msisdn}

                                    />
                                  </div> */}

                          <div class="modal-body">
                            <div class="row">
                              <div className="col-md-6 mt_2">
                                <div class="col-6">
                                  <label
                                    for="exampleInputEmail1"
                                    className="form-label"
                                  >
                                    Mobile Number:
                                  </label>
                                </div>

                                <input
                                  disabled
                                  className="form-control"
                                  placeholder="Mobile Number"
                                  type="text"
                                  minLength="3"
                                  // value={selectedUserDetail?.dltId}
                                  value={selectedUserDetail.msisdn}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="modal-footer">
                            <button
                              type="button"
                              className="btn btn-primary "
                              data-bs-dismiss="modal"
                              // onClick={() => {
                              //   rejectUserApi();
                              // }}
                            >
                              Yes
                            </button>
                            <button
                              type="button"
                              className="btn btn-secondary w_btn"
                              data-bs-dismiss="modal"
                            >
                              No
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {selectedUserDetailApprove != undefined && (
                  <div>
                    <button
                      ref={modelButtonApprove}
                      type="button"
                      className="btn btn-primary d-none"
                      data-bs-toggle="modal"
                      data-bs-target="#staticBackdrop1"
                    >
                      Launch static backdrop modal
                    </button>

                    <div
                      className="modal fade"
                      id="staticBackdrop1"
                      data-bs-backdrop="static"
                      data-bs-keyboard="false"
                      tabindex="-1"
                      aria-labelledby="staticBackdrop1Label"
                      aria-hidden="true"
                    >
                      <div className="modal-dialog">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5
                              className="modal-title"
                              id="staticBackdrop1Label"
                            >
                              Update Details
                            </h5>
                            <button
                              type="button"
                              className="btn-close"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                            ></button>
                          </div>
                          {/* <div className="modal-body">
                                    <TextField
                                      required={
                                        selectedUserDetailApprove != undefined
                                      }
                                      className="ms-4 w-50  "
                                      style={{
                                        borderRadius: "4px",
                                        marginTop: "10px",
                                      }}
                                      type="text"
                                      label="Mobile Number"
                                      name="msisdn1"
                                      variant="outlined"
                                      size="small"
                                      onChange={formik1.handleChange}
                                      value={formik1.values.msisdn1}
                                      error={
                                        formik1.touched.msisdn1 &&
                                        Boolean(formik1.errors.msisdn1)
                                      }
                                      helperText={
                                        formik1.touched.msisdn1 &&
                                        formik1.errors.msisdn1
                                      }
                                      
                                    />
                                  </div> */}
                          <div className="modal-body">
                            <div className="row">
                              <div className="col-md-6 mt_2">
                                <div class="col-6">
                                  <label
                                    for="exampleInputEmail1"
                                    className="form-label "
                                  >
                                    Mobile Number:
                                  </label>
                                </div>
                                {/* <input
                                          type="number"
                                          // title=""
                                          // pattern="[6789][0-9]{9}"
                                      
                                          // min="1000000000"
                                          // min="4"
                                        // max="10000000000"
                                          required
                                          value={phoneNumber}
                                          onChange={(e) => {
                                            setPhoneNumber(e.target.value);
                                          }}
                                          // value={selectedUserDetailApprove?.dltId}
                                          className="form-control"
                                          id="exampleInputEmail1"
                                          aria-describedby="emailHelp"
                                        /> */}
                                <input
                                  type="number"
                                  // title=""
                                  // pattern="[6789][0-9]{9}"

                                  // min="1000000000"
                                  // min="4"
                                  // max="10000000000"
                                  required
                                  // value={phoneNumber1}
                                  // value=""
                                  // onChange={(e) =>
                                  //   handlechangenumber(e)
                                  // }
                                  // value={selectedUserDetailApprove?.dltId}
                                  className="form-control select_5"
                                  id="exampleInputEmail1"
                                  aria-describedby="emailHelp"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="modal-footer">
                            <button
                              required
                              type="submit"
                              className="btn btn-primary editcolor"
                              // onClick={changeModal}
                              // data-bs-dismiss="modal"
                            >
                              Ok
                            </button>

                            <button
                              type="button"
                              className="btn btn-secondary w_btn20"
                              data-bs-dismiss="modal"
                              id="getcancel"
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div className="container-fluid">
                  <div class="mb-3 mt-4">
                    <div class=" mt-2">
                      <div>
                        {selectedFlatRows.length > 0 && (
                          <button onClick={deletUser}>Delete Users</button>
                        )}
                      </div>
                      <div className="table-responsive">

                      <table
                        {...getTableProps()}
                        id="example"
                        className="table table-striped table-bordered dataTable table-sm"
                        style={{ width: "100%" }}
                      >
                        <thead>
                          {headerGroups.map((headerGroup) => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                              {headerGroup.headers.map((column) => (
                                <th
                                  {...column.getHeaderProps(
                                    column.getSortByToggleProps()
                                  )}
                                  className="text-center width_2"
                                >
                                  {column.render("Header")}
                                  <span>
                                    {column.isSorted
                                      ? column.isSortedDesc
                                        ? "↑"
                                        : "↓"
                                      : ""}
                                  </span>
                                </th>
                              ))}
                            </tr>
                          ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                          {page.map((row) => {
                            prepareRow(row);
                            return (
                              <tr {...row.getRowProps()}>
                                {row.cells.map((cell) => {
                                  return (
                                    <td
                                      {...cell.getCellProps()}
                                      className="text-center"
                                    >
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
</div>

                      <div className="d-flex justify-content-between">
                        <div>
                        <span>
                                          Page:
                                          <strong>
                                            {/* {pageIndex + 0} of {pageOptions.length} */}
                                            {totalPageCount} of {totalPage}
                                          </strong>
                                        </span>
                                        <span>
                                          | Go to Page :{""}
                                          <input
                                            type="number"
                                            min="0"
                                            max={totalPage}
                                            // defaultValue={pageIndex}
                                            // defaultValue={totalPageCount}
                                            value={totalPageCount}
                                            // defaultValue={pageNumber1}
                                            onChange={(e) => {
                                              const pageNumber = e.target.value
                                                ? Number(e.target.value)
                                                : 0;
                                              gotoPage(pageNumber);
                                              setPageNumber1(pageNumber);
                                            }}
                                            style={{ width: "50px" }}
                                          />
                                        </span>
                        </div>

                        <div>
                        <button
                                          className="btn btn_primary m-0 primary_1 me-2"
                                          type="button"
                                          // disabled={!canPreviousPage}
                                          disabled={
                                            totalPageCount == 0
                                              ? disabledPrevious
                                              : false
                                          }
                                          onClick={() => {
                                            previousPage();
                                            PreviousPage();
                                          }}
                                        >
                                          Prev
                                        </button>

                                        <button
                                          className="btn btn_primary m-0 primary_1"
                                          type="button"
                                          // disabled={!canNextPage}
                                          disabled={
                                            totalPageCount == totalPage
                                              ? disableNext
                                              : false
                                          }
                                          onClick={() => {
                                            nextPage();
                                            NextPage();
                                          }}
                                        >
                                          Next
                                        </button>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default Uploadphonebook;
